import React from 'react';
import { AIThesisChange } from '../../../ai/responseSchema';

export function ThesisDeltaCard({ change }: { change: AIThesisChange }) {
  const cfg = {
    new:          { label: '★ NEW',         color: 'var(--cyan)'    },
    strengthened: { label: '↑ STRONGER',    color: 'var(--green)'   },
    weakened:     { label: '↓ WEAKER',      color: 'var(--amber)'   },
    unchanged:    { label: '→ UNCHANGED',   color: 'var(--blue-dim)'},
    invalidated:  { label: '⚠ INVALIDATED', color: 'var(--red)'     },
  };
  const c = cfg[change] || cfg.unchanged;
  return (
    <span style={{ fontSize: 9, fontFamily: 'var(--mono)', fontWeight: 700, color: c.color,
      border: `1px solid ${c.color}44`, background: `${c.color}12`,
      padding: '1px 6px', borderRadius: 3, letterSpacing: '.5px' }}>
      {c.label}
    </span>
  );
}
